import { InformationBlock } from '@/ui/index';
import SvgNote from '@/icons/Note';
import { SuccessTick } from '@/icons/index';

import { NewsItem, SliderContainer } from '../../common';

import styles from './Success.module.scss';

const Success = ({ data }) => {
  const content = {
    title: 'Success.<br />Thank you for the order',
    text: 'We are working 5 days a week from</br> 9 a.m. to 7 p.m. and will call you back</br> at the first opportunity soon',
  };

  return (
    <div
      className={styles.container}
      itemScope
      itemType='https://schema.org/Message'
    >
      <div className={'wrapper'}>
        <InformationBlock icon={<SuccessTick />} content={content} />
      </div>
      {!!data?.newsSlider && (
        <SliderContainer
          title={data?.newsSlider?.title}
          linkText={data?.newsSlider?.linkText}
          link={data?.newsSlider?.link}
          icon={SvgNote}
          options={data?.sliderOptions2}
          addClass={styles.newsSlider}
        >
          {data?.newsSlider?.list?.map((item, key) => (
            <NewsItem data={item} key={key} />
          ))}
        </SliderContainer>
      )}
    </div>
  );
};

export default Success;
